import React from 'react';

export const HumidityIcon = () => (
  <svg
    className="weather-icon"
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 4 C16 4, 8 12, 8 18 C8 22.4 11.6 26 16 26 C20.4 26 24 22.4 24 18 C24 12, 16 4, 16 4 Z"
      fill="none"
      stroke="#000000"
      strokeWidth="1.5"
    />
  </svg>
);
